import { GridCellParams } from '@mui/x-data-grid-pro';
import { v4 } from 'uuid';
import { GridCustomColDef } from '../../../types';
import { DetailCTARenderer } from '../../UpstackDataGrid/CellRenderers/DetailCTARenderer';
import { ComponentName, getMetaData } from '../../DetailsDrawer/detailsDrawersHelpers';
import { advancedBooleanOperators, advancedOperators } from '../../UpstackDataGrid/helpers';

export const BulkArchiveLinkGridColumnDefs: GridCustomColDef[] = [
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'details',
    headerName: '',
    sortable: false,
    width: 65,
    filterable: false,
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
        state={{
          id: v4(),
          data: params.row,
          ...getMetaData({
            name: ComponentName.LINK,
            id: params.row.id,
            data: params.row
          })
        }}
      />
    ),
    hideable: false,
    pinned: 'left'
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'rpmAccountId',
    headerName: 'RPM Account ID',
    sortable: true,
    flex: 1,
    minWidth: 150,
    filterable: true,
    description: 'Drag to move column',
    filterOperators: advancedOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'rpmAccountNumber',
    headerName: 'RPM Account Number',
    sortable: true,
    flex: 1,
    minWidth: 170,
    filterable: true,
    description: 'Drag to move column',
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={params.row.rpmAccountNumber}
        valueFormatted={''}
        state={{
          id: '',
          type: 'rpmAccount',
          data: params.row,
          ...getMetaData({ name: ComponentName.RPM_ACCOUNT, id: params.row.rpmAccountId })
        }}
      />
    ),
    filterOperators: advancedOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'rpmAccountSupplierName',
    headerName: 'RPM Supplier',
    sortable: true,
    filterable: true,
    flex: 1,
    minWidth: 170,
    description: 'Drag to move column',
    filterOperators: advancedOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'assetNumber',
    headerName: 'Asset',
    sortable: true,
    flex: 1,
    minWidth: 150,
    filterable: false,
    renderCell: (params: GridCellParams) =>
      params.row.assetNumber ? (
        <DetailCTARenderer
          data={params}
          value={params.row.assetNumber}
          valueFormatted={''}
          state={{
            id: '',
            type: params.row.assetSfId ? 'asset' : 'provisionalAsset',
            data: params.row,
            ...getMetaData({
              name: ComponentName.ASSET,
              sfId: params.row.assetSfId,
              id: params.row.assetId,
              data: params.row.assetSfId ? params.row : null
            })
          }}
        />
      ) : (
        <></>
      )
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'status',
    headerName: 'Link Status',
    sortable: true,
    filterable: true,
    flex: 1,
    minWidth: 120,
    description: 'Drag to move column',
    valueGetter: (value, row) => (row.archived ? 'Archived' : row.candidate ? 'Candidate' : 'Active'),
    filterOperators: advancedBooleanOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'assetSalesAgent',
    headerName: 'Sales Agent',
    sortable: true,
    filterable: true,
    flex: 1,
    minWidth: 200,
    description: 'Drag to move column',
    filterOperators: advancedOperators()
  }
];
